import React, { useContext, useEffect, useState } from 'react'

import { ArrowDownwardRounded, ArrowUpwardRounded, MoreVertRounded, UnfoldMoreRounded } from '@mui/icons-material';
import { CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Fade from '@mui/material/Fade';
import AuthContext from '../../context/AuthContext';

import ModalContext from '../../context/ModalContext';
import DrawerContext from '../../context/DrawerContext';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import CustomButton from '../../common/CustomButton';
import PageSearchBar from '../../common/PageSearchBar';

function formatJoinedDate(createdAt) {
  if (!createdAt) return '-';
  try {
    return new Date(createdAt).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return '-';
  }
}

export default function CustomPaginationActionsTable() {

  const modalCtx = useContext(ModalContext);
  const drawerCtx = useContext(DrawerContext);
  const authCtx = useContext(AuthContext);

  const [selectedUser, setSelectedUser] = useState(null);
  const [usersData, setusersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [displayedData, setDisplayedData] = useState([]);
  const [anchorElFilter, setAnchorElFilter] = React.useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterValue, setFilterValue] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [nameSortOrder, setNameSortOrder] = useState(null); // null | 'asc' | 'desc' — null = default (by date)

  const handleStatus = (status) => {
    // switch (status) {
    //   case 'active':
    //     return <div className='status-active'>Active</div>
    //     break;

    //   case 'invite_sent':
    //     return <div className='status-invite'>Invite Sent</div>
    //     break;

    //   default:
    //     break;
    // }
    if (status == "pending") {
      return <div class='status-pending'>Pending</div>;
    } else if (status == "invite_sent") {
      return <div className='status-invite'>Invite Sent</div>;
    } else if (status == "active") {
      return <div className='status-active'>Active</div>;
    } else if (status == "suspended") {
      return <div class='status-suspended'>Suspended</div>;
    }
  }



  const getAllUsers = () => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_API_URI}/v3/users`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: "Bearer " + authCtx.token }
    })
    .then(response => {
      return response.json();
    })    .then(data => {
      if (data.status == 'success') {
        setLoading(false);
        const sorted = (data?.data || []).slice().sort((a, b) => {
          const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
          const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
          return dateB - dateA;
        });
        setusersData(sorted);
      }
    }).catch(err => {
      console.error(err)
      // setUpdatingStatus(false)
    });

  }


  useEffect(() => {
    getAllUsers();
  }, [])


  const handleModal = (modal, data) => {
    handleClose();
    modalCtx.openModal();
    modalCtx.setDetails(modal, data);
  }

  function toggleDrawerHandler(drawer, user) {
    drawerCtx.openDrawer();
    drawerCtx.setDetails(drawer, user);
  };

  const open = Boolean(anchorEl);
  const handleClick = (event, data) => {
    setSelectedUser(data);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNameSortClick = () => {
    setNameSortOrder((prev) => (prev === null ? 'asc' : prev === 'asc' ? 'desc' : null));
  };

  useEffect(() => {
    const filteredData = (usersData || []).filter((data) => {
      const term = (searchInput || '').toLowerCase();
      if (!term) return true;
      return (
        (data?.name && data.name.toLowerCase().includes(term)) ||
        (data?.email && data.email.toLowerCase().includes(term)) ||
        (data?.username && data.username.toLowerCase().includes(term)) ||
        (data?.keywords && data.keywords.toLowerCase().includes(term))
      );
    });
    const sorted = filteredData.slice().sort((a, b) => {
      if (nameSortOrder === 'asc') {
        const nameA = (a?.name ?? '').toLowerCase();
        const nameB = (b?.name ?? '').toLowerCase();
        return nameA.localeCompare(nameB);
      }
      if (nameSortOrder === 'desc') {
        const nameA = (a?.name ?? '').toLowerCase();
        const nameB = (b?.name ?? '').toLowerCase();
        return nameB.localeCompare(nameA);
      }
      const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return dateB - dateA;
    });
    setDisplayedData(sorted);
  }, [usersData, filterValue, searchInput, loading, nameSortOrder])

  const handleFilterChange = (event) => {
    setFilterValue(event.target.value);
  }
  
  const open2 = Boolean(anchorElFilter);
  const handleClickFilter = (event) => {
    setAnchorElFilter(event.currentTarget);
  };

  const handleCloseFilter = (value) => {
    setAnchorElFilter(null);
    setFilterValue(value)
  };

  const handleDeleteClick = (user) => {
    handleClose();
    modalCtx.setDetails('delete-user-modal', {
      user,
      onDeleted: getAllUsers
    });
    modalCtx.openModal();
  };

  return (
    <>
      <div className="users-container">
        <div className='header-section'>
          <span className='title'>USERS</span>
          <div className='header-items-div'>
            <PageSearchBar value={searchInput} onChange={(e) => setSearchInput(e.target.value)} placeholder="Search" />
            <div>
              <CustomButton onClick={handleClickFilter} className={'deliva-btn-bordered'} >
                Filter By :- {filterValue !== '' ? filterValue : 'All'}
              </CustomButton>
              <Menu id="basic-menu" anchorEl={anchorElFilter} open={open2} onClose={() => handleCloseFilter('')}>
                <MenuItem onClick={() => handleCloseFilter('user')}>User</MenuItem>
                {/* <MenuItem onClick={()=>handleCloseFilter('rescue')}>Rescue</MenuItem>
                <MenuItem onClick={()=>handleCloseFilter('police')}>Police</MenuItem>
                <MenuItem onClick={()=>handleCloseFilter('shelters')}>Shelters</MenuItem>
                <MenuItem onClick={()=>handleCloseFilter('fire')}>Fire</MenuItem>
                <MenuItem onClick={()=>handleCloseFilter('pests')}>Pests</MenuItem>
                 */}
                <MenuItem onClick={() => handleCloseFilter('')}>All</MenuItem>
              </Menu>
            </div>
          </div>
        </div>
        <TableContainer component={Paper} className='user-table' sx={{ height: '100%', overflow: 'auto' }}>
          <Table sx={{ minWidth: 500 }} stickyHeader>
          <TableHead className='user-table-head'>
            <TableRow>
              <TableCell align="left" className="user-head-cell name-sort-cell" sortDirection={nameSortOrder || false}>
                <span
                  role="button"
                  tabIndex={0}
                  onClick={handleNameSortClick}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleNameSortClick(); } }}
                  className="name-sort-label"
                  aria-label={nameSortOrder === 'asc' ? 'Sort by name descending' : nameSortOrder === 'desc' ? 'Remove sort' : 'Sort by name ascending'}
                >
                  Name
                  {nameSortOrder === 'asc' && <ArrowUpwardRounded sx={{ fontSize: 18, ml: 0.5, verticalAlign: 'middle', color: '#535c68' }} />}
                  {nameSortOrder === 'desc' && <ArrowDownwardRounded sx={{ fontSize: 18, ml: 0.5, verticalAlign: 'middle', color: '#535c68' }} />}
                  {nameSortOrder === null && <UnfoldMoreRounded sx={{ fontSize: 18, ml: 0.5, verticalAlign: 'middle', color: '#535c68', opacity: 0.8 }} />}
                </span>
              </TableCell>
              <TableCell align="left" className="user-head-cell">Email</TableCell>
              <TableCell align="left" className="user-head-cell">Phone</TableCell>
              <TableCell align="left" className="user-head-cell">Location</TableCell>
              <TableCell align="left" className="user-head-cell">Joined on</TableCell>
              <TableCell align="left" className="user-head-cell">Affiliate Code</TableCell>
              <TableCell align="right" className="user-head-cell"></TableCell>
            </TableRow>
          </TableHead>
            <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              displayedData.map((data) => (
                <TableRow key={data.id} className="user-table-row" style={{ backgroundColor: 'white' }}>
                  <TableCell className="user-table-cell" style={{ width: 150 }} align="left">
                    <span>{data.name ?? '-'}</span>
                  </TableCell>
                  <TableCell className="user-table-cell" style={{ width: 150 }} align="left">
                    {data.email ?? '-'}
                  </TableCell>
                  <TableCell className="user-table-cell" style={{ width: 150 }} align="left">
                    {data.phone ?? '-'}
                  </TableCell>
                  <TableCell className="user-table-cell" style={{ width: 160 }} align="left">
                    {data.country ?? '-'}
                  </TableCell>
                  <TableCell className="user-table-cell" style={{ width: 140 }} align="left">
                    {formatJoinedDate(data.createdAt)}
                  </TableCell>
                  <TableCell className="user-table-cell" style={{ width: 120 }} align="left">
                    {data.affiliateCode && data.affiliateCode.trim() !== '' ? data.affiliateCode : '-'}
                  </TableCell>
                  <TableCell className="user-table-cell" style={{ width: '80px' }} align="right" padding="none">
                    <div className="icons-container">
                      <MoreVertRounded
                        aria-controls={open ? 'fade-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={(e) => handleClick(e, data)}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'fade-button' }}
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 120 }}
      >
        <MenuItem
          onClick={() => { selectedUser && handleDeleteClick(selectedUser); handleClose(); }}
          sx={{ color: 'error.main' }}
        >
          Delete
        </MenuItem>
      </Menu>
    </>
  );
}
